import { Outlet } from 'react-router';

import styles from '@/components/shell/LegacyFrame.module.css';

/**
 * A frame for screens that predate the Index Book. The screen lanes replace
 * these routes one by one; until then they sit in the new shell unchanged.
 * Each renders its own `Page`, which carries the gutters and the column, so
 * the frame adds none.
 */
export function LegacyFrame() {
  return (
    <div className={styles.frame}>
      <Outlet />
    </div>
  );
}
